<template>
  <div>
    <b-dropdown
      id="branches-dropdown"
      ref="dropdown"
      v-ripple.400="'rgba(186, 191, 199, 0.15)'"
      :text="currentBranchSelected.name"
      :disabled="disabled"
      class="branches-dropdown"
      variant="outline-secondary"
    >
      <b-dropdown-item-button
        v-if="allOption"
        button-class="w-100"
        :active="isActive('all')"
        @click="setBranch('all', null)"
      >
        {{ $t('notifications.all') }}
      </b-dropdown-item-button>
      <template v-for="branch in orderedBranches">
        <b-dropdown-item-button
          :key="branch.id"
          button-class="w-100"
          :active="isActive(branch.id)"
          @click="setBranch(branch.id, branch)"
        >
          {{ branch.name }}
        </b-dropdown-item-button>
      </template>

      <template v-if="showAddBranch">
        <b-dropdown-divider />

        <b-dropdown-item-button
          v-if="canManageBranches"
          id="add-branch-dropdown-option"
          button-class="w-100"
          @click="addBranch"
        >
          {{ $t('branch.add-branch') }}
        </b-dropdown-item-button>
      </template>
    </b-dropdown>

    <app-tour
      :steps="steps"
      custom-class="branch-tour"
    />
  </div>
</template>

<script>
import {
  BDropdownDivider, BDropdownItemButton, BDropdown,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { mapGetters } from 'vuex'
import orderBy from 'lodash/orderBy'
import PermissionMixin from '@/mixins/permission-mixin'
import SUBUSER_PERMISSION_SLUGS from '@/constants/authorization/subuser-permission-slugs'

export default {
  name: 'BranchesDropdown',
  components: {
    AppTour: () => import(/* webpackChunkName: "3rd-libs" */ '@core/components/app-tour/AppTour'),
    BDropdown,
    BDropdownItemButton,
    BDropdownDivider,
  },
  directives: { Ripple },
  mixins: [PermissionMixin],
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    local: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Array,
      default: () => [],
    },
    allOption: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      branches: 'branches/branches',
      currentBranch: 'branches/currentBranch',
      addBranchTour: 'branches/addBranchTour',
    }),
    currentBranchSelected() {
      // eslint-disable-next-line no-nested-ternary
      return (this.local ? (this.value[0] ? { ...this.value[0], name: `${this.value[0].name} ${this.value.length > 1 ? `+${this.value.length - 1}` : ''}` } : null) : this.currentBranch) ?? { name: this.$t('notifications.all') }
    },
    orderedBranches() {
      return orderBy(this.branches, ['name'], ['asc'])
    },
    showAddBranch() {
      return false
    },
    canManageBranches() {
      return this.hasSubuserPermission(SUBUSER_PERMISSION_SLUGS.BRANCHES_MANAGE)
    },
    steps() {
      return [
        {
          target: '#branches-dropdown',
          content: this.$t('branch.add-branch-tour-1'),
        },
        {
          target: '#add-branch-dropdown-option',
          content: this.$t('branch.add-branch-tour-2'),
          before: () => new Promise(resolve => {
            this.$refs.dropdown.show()
            setTimeout(resolve, 100)
          }),
        },
      ]
    },
  },
  watch: {
    addBranchTour(visible) {
      if (visible) {
        this.tourStart()
        this.$nextTick(() => this.$store.commit('branches/SET_ADD_BRANCH_TOUR', false))
      }
    },
  },
  methods: {
    tourStart() {
      this.$tours.okTour.start()
    },
    setBranch(branchId, branch) {
      if (this.local) {
        let newBranches = []
        if (this.value.find(el => el.id === branchId)) {
          newBranches = [...this.value.filter(el => el.id !== branchId)]
        } else {
          newBranches = [...this.value, branch]
        }
        this.$emit('input', branchId === 'all' ? [] : newBranches)
      } else {
        this.$store.dispatch('branches/SET_BRANCH', branchId)
      }
    },
    isActive(branchId) {
      if (branchId === 'all') {
        return this.value.length === 0
      }
      return Boolean((this.local ? this.value.find(el => el.id === branchId) : this.currentBranch.id === branchId))
    },
    addBranch() {
      this.$store.dispatch('branches/REQUEST_ADD_BRANCH')
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/tour.scss';

.branch-tour {
  .v-step {
    min-width: 220px!important;
    max-width: 220px!important;
    left: 12px!important;
  }

}

#branches-dropdown {
  .dropdown-menu {
    overflow: auto;
    max-height: 25rem;
  }
}
</style>
